export default __webpack_public_path__ + "static/media/oscer-pres-vaginal-discharge.83d99a4d.svg";